import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC, ReactNode } from 'react';

import { Group } from 'STORE/Groups/Group';

import { DotLoader } from './DotLoader/DotLoader';
import { useGroupStatusPresenter } from './GroupStatus.presenter';
import styles from './GroupStatus.styles.m.css';

interface IGroupStatusProps {
  group: Group;
  children: ReactNode;
  className?: string;
}

export const GroupStatus: FC<IGroupStatusProps> = observer((props) => {
  const { group, children, className } = props;
  const presenter = useGroupStatusPresenter(group);

  if (presenter.status) {
    return (
      <div className={classNames(styles.container, className)}>
        <DotLoader className={styles.loader} />
        <span className={styles.status}>{presenter.status}</span>
      </div>
    );
  }

  return children;
});
